module.exports = __webpack_public_path__ + "images/credit-card.4b45b8eb758c20a81053d09593e4cc7e.svg";